export const config = {
  pagination: false,
  rowSelection: false,
  search: false,
  columns: [
    {
      title: '调整时间',
      dataIndex: 'lastUpdatedTime',
      width: 160,
      itemType: 'dateTime'
    },
    {
      title: '变更前',
      dataIndex: 'changeBefore',
      width: 250,
      ellipsis: true,
    },
    {
      title: '变更后',
      dataIndex: 'changeAfter',
      width: 250,
      ellipsis: true,
    },
    {
      title: '调整人',
      dataIndex: 'createdByName',
      width: 150,
      ellipsis: true,
    },
  ],
}